var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSvgFooterMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4914 4.67294L14.6477 4.0167C14.3387 3.94561 14.0216 4.10693 13.8958 4.39677L12.5833 7.45921C12.4685 7.72717 12.545 8.04162 12.772 8.22482L14.429 9.58104C13.4446 11.6783 11.7247 13.4228 9.58377 14.4262L8.22754 12.7693C8.04161 12.5423 7.7299 12.4657 7.46193 12.5806L4.3995 13.8931C4.10692 14.0216 3.9456 14.3387 4.01669 14.6477L4.67293 17.4914C4.74129 17.7867 5.00378 18 5.31276 18C12.3153 18 18 12.3263 18 5.31277C18 5.00652 17.7895 4.7413 17.4914 4.67294Z",
    fill: "#0562FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgFooterMail);
export default __webpack_public_path__ + "static/media/SvgFooterMail.47c7ade45a5fdf698350744a6881e291.svg";
export { ForwardRef as ReactComponent };